import { ISalonHeader } from '@app/shared/models';

export interface ISalonReviewsItem {
  id: string;
  createdOnUtc: Date;
  customerFirstName?: string;
  salonRating: number;
  employeesRating: number;
  treatmentRating: number;
  description: string;
  salon?: ISalonHeader;
  salonReply?: { createdOnUtc: Date; replyText: string };

  averageRating?: number;
  showPartialRatings?: boolean;
}
